import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/hooks";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { library } from "../../redux/library/action";
import { cmsSettings } from "../../redux/cmsSettings/action";
import { states } from "../../redux/states/action";
import { countries } from "../../redux/countries/action";
import PageLoader from "../../components/PageLoader";
import _ from "lodash";
import { selectCurrent } from "../../redux/settings/selectors";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { selectAuth } from "../../redux/auth/selectors";
import IshipXLogin from "../auth/ishipx";

const IshipxHome = () => {
    //#region hooks
    const dispatch = useAppDispatch();
    const { height, width } = useWindowDimensions();
    const result = useSelector(selectCurrent)
    const { isGuestTokenReady, isThemeAvailable } = result
    const deferredAPICalls = async () => {
        if (isGuestTokenReady) {
            await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library', options: { authorization_required: false } }))
            await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries', options: { authorization_required: false } }))
            await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states', options: { authorization_required: false } }))
            await dispatch(cmsSettings.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {}, options: { authorization_required: false } }))
        }
    }
    useEffect(() => {
        if (isThemeAvailable) {
        }
    }, [isThemeAvailable]);

    useEffect(() => {
        console.log('Index page loading')
        if (isGuestTokenReady) {
            deferredAPICalls();

        }
    }, [isGuestTokenReady]);


    //#endregion

    const authToken = useSelector(selectAuth)
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)

    useEffect(() => {
        if (localStorage.getItem('access-token')) {
            setIsUserLoggedIn(true);
        } else {
            setIsUserLoggedIn(false);
        }
    }, [authToken])

    return (
        <>
            {!isGuestTokenReady ? <PageLoader /> :
                <>
                    {width && width < 720 ? (
                        //  Start - Mobile View  
                        <div className={`max-h-screen w-screen mt-20`}>

                        </div>
                        //  End - Mobile View  
                    ) : width && width >= 720 && width < 1024 ? (
                        //  Start - Tablet View
                        <div className={`max-h-screen w-screen mt-24`}>
                            <div className={`flex flex-col items-center justify-center w-full bg-skin-primary`}>
                            </div>
                        </div>
                        //  End - Tablet View
                    ) : (
                        //  Start - Web View  
                        <div className={`flex flex-col items-center justify-center w-full overflow-y-auto bg-skin-primary`}>
                            <IshipXLogin />
                        </div>
                        //  End - Web View  
                    )}
                </>
            }
        </>
    )
}

export default IshipxHome



